"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloaterTechnology = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var ResourceType_1 = require("../../ResourceType");
var AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
var Card_1 = require("../Card");
var CardRenderer_1 = require("../render/CardRenderer");
var FloaterTechnology = (function (_super) {
    __extends(FloaterTechnology, _super);
    function FloaterTechnology() {
        return _super.call(this, {
            cost: 7,
            tags: [Tags_1.Tags.SCIENCE],
            name: CardName_1.CardName.FLOATER_TECHNOLOGY,
            cardType: CardType_1.CardType.ACTIVE,
            metadata: {
                cardNumber: 'C12',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Add 1 floater to ANOTHER card.', function (eb) {
                        eb.empty().startAction.floaters(1).asterix();
                    });
                }),
            },
        }) || this;
    }
    FloaterTechnology.prototype.canAct = function (player) {
        return player.getResourceCards(ResourceType_1.ResourceType.FLOATER).length > 0;
    };
    FloaterTechnology.prototype.action = function (player) {
        var floaterCards = player.getResourceCards(ResourceType_1.ResourceType.FLOATER);
        if (floaterCards.length) {
            player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.FLOATER, { count: 1 }));
        }
        return undefined;
    };
    FloaterTechnology.prototype.play = function () {
        return undefined;
    };
    return FloaterTechnology;
}(Card_1.Card));
exports.FloaterTechnology = FloaterTechnology;
//# sourceMappingURL=FloaterTechnology.js.map